<div style="margin: .5em 0 .5em 0" *ngIf="display">
  @for (message of messages(); track message) {
  <p-message [severity]="message.severity" [text]="message.text" [icon]="iconBySeverity(message.severity)" *ngIf="message.key==key"  [closable]="closable"/>
  }
</div>
